<script>
    import PasswordSetter from '../components/PasswordSetter.svelte';
    import Spinner from '../components/Spinner.svelte';
	import AuthContext from '../layouts/AuthContext.svelte';
	import firebase from '../firebase';
    
	let password = '';
	let isValidPassword;
	let message;
    let promise;

	const changePassword = async () => {
		message = null;
		promise = (async () => {
            if (!isValidPassword) throw { message: 'Password is not valid.' };
			await firebase.auth().currentUser.updatePassword(password)
		})()
			.then(() => message = { type: 'success', text: 'Password updated' })
			.catch(error => message = { type: 'error', text: error.message });
	}
</script>

<AuthContext title="Change password" on:enterPressed={changePassword}>
    <div class="modal modal--uncentred">
        <div class="modal__box modal__box--md">
            <div class="modal__header">
                Change password
            </div>
            <div class="modal__body layout">
                <div class="layout__column">
                    <PasswordSetter bind:password={password} bind:isValid={isValidPassword} />
                    {#if message}
                        <div class="layout__item {message.type}-message">{message.text}</div>
                    {/if}
					<div class="layout__row layout__row--right">
                        <div class="layout__item">
                            {#await promise}
                                <div class="form__button form__button--disabled"><Spinner />Change password</div>
                            {:then result}
                                <div class="form__button" on:click={changePassword}>Change password</div>
                            {/await}
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</AuthContext>